import { createSlice } from "@reduxjs/toolkit";
import { PostIsShown } from "../API/Appointment";


const initialState = {
    IsShown: [],
    loading: false,
    error: null,
};

const AppointmentsSlice = createSlice({
  name: "Appointments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(PostIsShown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(PostIsShown.fulfilled, (state, action) => {
        state.loading = false;
        state.IsShown = action.payload;
      })
      .addCase(PostIsShown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default AppointmentsSlice.reducer;
